import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

export const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        message: "",
    });

    const toPersianDigits = (str) => {
        return str.replace(/\d/g, (d) => String.fromCharCode(d.charCodeAt(0) + 1728));
      };

      const handleChange = (e) => {
        const { name, value } = e.target;
      
        if (name === "phone") {
          // Convert Persian digits to English
          const englishValue = value.replace(/[۰-۹]/g, (d) =>
            String.fromCharCode(d.charCodeAt(0) - 1728)
          );
      
          // Keep only numbers, max 10
          const cleaned = englishValue.replace(/\D/g, "").slice(0, 10);
      
          setFormData((prev) => ({
            ...prev,
            phone: cleaned,
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            [name]: value,
          }));
        }
      };
      

    const generateWhatsAppLink = () => {
        const toPhone = "989155838178"; // Replace with your own WhatsApp number
        const msg = `سلام، من ${formData.name} هستم. شماره تماس من: 98${formData.phone}. پیام: ${formData.message}`;
        return `https://wa.me/${toPhone}?text=${encodeURIComponent(msg)}`;
    };

    const isValid =
        formData.name.trim() &&
        formData.phone.trim().length === 10 &&
        formData.message.trim();

    return (
        <div className="max-w-xl mx-auto p-6">
            <h2 className="text-2xl font-bold mb-4 text-amber-950 mt-20">ارتباط با ما</h2>

            <div className="space-y-4 text-xs">
                <input
                    type="text"
                    name="name"
                    placeholder="نام شما"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full p-2 border rounded"
                />

                <div className="flex items-center gap-2 justify-start direction-rtl">
                    {/* Phone Number Input */}
                    <input
                        type="tel"
                        name="phone"
                        placeholder="۹۱۲۳۴۵۶۷۸۹"
                        value={toPersianDigits(formData.phone)}
                        onChange={handleChange}
                        required
                        className="flex-1 p-2 border rounded text-left"
                        maxLength={10}
                        pattern="[0-9]*"
                        inputMode="numeric"
                    />

                    {/* Fixed +98 Prefix Input (Read-only) */}
                    <div className="w-20">
                        <input
                            type="text"
                            value="۹۸+"
                            readOnly
                            className="w-full p-2 border rounded bg-gray-100 text-center cursor-not-allowed"
                        />
                    </div>
                </div>


                <textarea
                    name="message"
                    placeholder="پیام شما"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={4}
                    className="w-full p-2 border rounded"
                />

                <div className="mt-6 text-center">
                    {isValid ? (
                        <a
                            href={generateWhatsAppLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center w-full text-white py-2 px-4 rounded bg-gradient-to-r from-[#d1927f] to-[#78350f] hover:opacity-90"
                        >
                            <FaWhatsapp className="ml-2" size={20} />
                            ارسال در واتساپ
                        </a>
                    ) : (
                        <span className="inline-flex items-center justify-center w-full text-gray-400 py-2 px-4 rounded bg-gray-200 cursor-not-allowed">
                            <FaWhatsapp className="ml-2" size={20} />
                            ابتدا فرم را کامل کنید
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
